module.exports = __webpack_public_path__ + "static/sosv-logo-3af932c850324e0e51505388bb29d6d6.png";